import { Box } from "@mui/material";
import { formatCurrency } from "../../../../utils/formatters";

type ItemTotalsProps = {
  total: number;
  savings?: number;
};
export const ItemTotalsSummary = ({ total, savings }: ItemTotalsProps) => {
  const savingsColor = !!savings && savings > 0 ? "#EA5455" : "#28C76F";
  const savingsSign = !!savings && savings > 0 ? "+" : "-";
  return (
    <Box display={"flex"} justifyContent={"space-between"} flex={1}>
      <span>Total</span>
      <span style={{ marginBottom: 4 }}>
        {formatCurrency(total)}
        {!!savings && savings !== 0 && (
          <Box sx={{ color: savingsColor, ml: 1 }}>
            {savingsSign} {formatCurrency(Math.abs(savings))}
          </Box>
        )}
      </span>
    </Box>
  );
};
